import React, { useEffect, useState } from "react";
import StatsComponent from "../common/StatsComponent";
import AreaCharts from "../common/AreaChart";
import HorziBarChartsMain from "../common/HorizontalStackBarChart2";
import {
  downloadSanctionedDataByDateRange,
  getSanctionLeadsByDateRange,
  getSanctionStatsByDateRange,
  getSanctionTrendDataByDateRange,
} from "../ActionCreator";
import moment from "moment";
import CustomDateFilter from "../common/CustomDateFilter";
import { Pagination, Stack } from "@mui/material";
import Loader from "../../../../presentationals/Loader/Loader.component";
import DateFilterSelect from "../../../../CustomDatePicker/DateFilterSelect";

const customMargin = window.innerWidth > 1800 ? "70px" : "50px";

export default function Saction({
  dateFilterPopup,
  handleDateFilterPopup,
  dateType,
  setDateType,
  updateDateRange
}) {
  // const [dateFilterPopup, setDateFilterPopup] = useState({
  //   show: false,
  //   from: moment(new Date()).format("YYYY-MM-DD"),
  //   to: moment(new Date()).format("YYYY-MM-DD"),
  // });
  const [tableData, setTableData] = useState([]);
  const [statsOption, setStatsOption] = useState({
    "Total Approved Leads": "1250",
    "Approved Amount (₹)": "₹62.5 Cr",
    "Disbursed Leads": "940",
    "Pending for Disbursement": "310",
    "Drop-off After Approval (%)": "9.6%",
    "Total API Cost": "₹18,75,000",
  });
  const [totalCount, setTotalCount] = useState(0);
  const [chartData, setchartData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [noOfRows, setNoOfRows] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(false);


  // const handleDateFilterPopup = (type, val) => {
  //   setDateFilterPopup((prev) => ({ ...prev, [type]: val }));
  // };

  const handleApplyDteFilter = () => {
    handleDateFilterPopup("show", false);
    handleApplyFilter();
  };

  const getSanctionTrendDataByDateRangeFn = (dateFilterPopup) => {
    setIsLoading(true);
    const sDate = moment(dateFilterPopup?.from)?.format("DD-MM-YYYY");
    const eDate = moment(dateFilterPopup?.to)?.format("DD-MM-YYYY");
    getSanctionTrendDataByDateRange(sDate, eDate, "daily", (res) => {
      setIsLoading(false);
      setchartData(res?.data || []);
    });
  };

  const getSanctionStatsByDateRangeFn = (dateFilterPopup) => {
    setIsLoading(true);

    const sDate = moment(dateFilterPopup?.from)?.format("DD-MM-YYYY");
    const eDate = moment(dateFilterPopup?.to)?.format("DD-MM-YYYY");
    getSanctionStatsByDateRange(sDate, eDate, (res) => {
      setIsLoading(false);
      setStatsOption(() => ({
        "Total Approved Leads": res?.data?.totalApprovedLeads ?? 0,
        "Approved Amount (₹)": `₹${res?.data?.totalApprovedAmount ?? 0}`,
        "Disbursed Leads": res?.data?.disbursedLeadsCount ?? 0,
        "Pending for Disbursement": res?.data?.pendingForDisbursement ?? 0,
        "Drop-off After Approval": `${res?.data?.dropOffAfterApproval ?? 0}`,
        "Total API Cost": `₹${Number(res?.data?.totalApiCosting).toFixed(2) ?? 0}`,
      }));
    });
  };

  const getSanctionLeadsByDateRangeFn = (dateFilterPopup, page) => {
    setIsLoading(true);
    const sDate = moment(dateFilterPopup?.from)?.format("DD-MM-YYYY");
    const eDate = moment(dateFilterPopup?.to)?.format("DD-MM-YYYY");
    getSanctionLeadsByDateRange(sDate, eDate, page, 10, (res) => {
      setIsLoading(false);
      setTableData(res?.data?.data || []);
      setTotalCount(res?.data?.totalCount || 0);
    });
  };

  const mainApiCall = (dateFilterPopup) => {
    getSanctionTrendDataByDateRangeFn(dateFilterPopup);
    getSanctionStatsByDateRangeFn(dateFilterPopup);
  };

  useEffect(() => {
    mainApiCall(dateFilterPopup);
  }, [dateFilterPopup.from, dateFilterPopup.to]);

  useEffect(() => {
    getSanctionLeadsByDateRangeFn(dateFilterPopup, pageNumber);
  }, [pageNumber]);

  const handleApplyFilter = () => {
    mainApiCall(dateFilterPopup);
    getSanctionLeadsByDateRangeFn(dateFilterPopup, pageNumber);
  };

  const handleReset = () => {
    // setPayload({
    //   search: "",
    //   apiType: "",
    //   status: "",
    // });
    const today = moment();
    setIsFilterCleared(true)

    const resetDate = {
      show: false,
      from: today.clone().subtract(6, "days").format("YYYY-MM-DD"),
      to: today.format("YYYY-MM-DD"),
    };
    setDateType('7')

    // setDateFilterPopup(resetDate);
    setPageNumber(1);
    mainApiCall(resetDate);
    getSanctionLeadsByDateRangeFn(resetDate, 1);
  };

  const handleExport = () => {
    const sDate = moment(dateFilterPopup?.from).format("DD-MM-YYYY");
    const eDate = moment(dateFilterPopup?.to).format("DD-MM-YYYY");

    downloadSanctionedDataByDateRange(sDate, eDate, (blob) => {
      if (!blob) return;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `Report_${sDate}_to_${eDate}.xls`;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    });
  };

  return (
    <>
      <div className="HeadingFilter-main-filters">
        <div className="row">
          <div
            className="col-xl-9 col-lg-10 col-xs-12"
            style={{ display: "flex", gap: "10px", marginTop: "5px" }}
          >
            {/* <div className="custom-popup" style={{ width: "25%" }}>
              <div
                className="customSelectBox "
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "20px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  handleDateFilterPopup("show", !dateFilterPopup?.show)
                }
              >
                <div
                  style={{
                    display: "flex",
                    gap: "7px",
                    alignItems: "center",
                  }}
                >
                  <svg
                    width="9"
                    height="9"
                    viewBox="0 0 9 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 0.75V2.25M3 0.75V2.25"
                      stroke="#0C0B10"
                      stroke-width="0.5625"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.875 1.5H4.125C2.71079 1.5 2.00368 1.5 1.56434 1.93934C1.125 2.37868 1.125 3.08579 1.125 4.5V5.25C1.125 6.6642 1.125 7.37134 1.56434 7.81065C2.00368 8.25 2.71079 8.25 4.125 8.25H4.875C6.2892 8.25 6.99634 8.25 7.43565 7.81065C7.875 7.37134 7.875 6.6642 7.875 5.25V4.5C7.875 3.08579 7.875 2.37868 7.43565 1.93934C6.99634 1.5 6.2892 1.5 4.875 1.5Z"
                      stroke="#0C0B10"
                      stroke-width="0.5625"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M1.125 3.75H7.875"
                      stroke="#0C0B10"
                      stroke-width="0.5625"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {dateFilterPopup?.from && dateFilterPopup?.to
                    ? `${moment(dateFilterPopup?.from).format("DD MMM YYYY")} - ${moment(dateFilterPopup?.to).format("DD MMM YYYY")}`
                    : "Select Date"}
                </div>
                <div style={{ marginTop: "-5px" }}>
                  <svg
                    width="8"
                    height="4"
                    viewBox="0 0 8 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.375 0.375025C7.375 0.375025 4.79731 3.375 3.875 3.375C2.95263 3.375 0.375 0.375 0.375 0.375"
                      stroke="#686C70"
                      stroke-width="0.75"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              {dateFilterPopup?.show ? (
                <CustomDateFilter
                  payload={dateFilterPopup}
                  handlechange={handleDateFilterPopup}
                  handleApply={handleApplyDteFilter}
                />
              ) : (
                ""
              )}
            </div> */}
            <DateFilterSelect
                                                                                   onChange={(range) => {
    updateDateRange(range[0], range[1], "custom");
  }}
              type={dateType}
                isFilterCleared={isFilterCleared}
              onTypeChange={setDateType}
              dateFilterPopup={dateFilterPopup}
            />
          </div>
          <div
            className="col-xl-3 col-lg-2 col-xs-12"
            style={{ marginTop: "5px" }}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: window.innerWidth > 1200 ? "end" : "start",
              }}
            >
              {/* <div className="custom-btn" onClick={handleApplyFilter}>
                <i
                  class="fa fa-filter"
                  style={{
                    fontSize: window.innerWidth >= 1800 ? "20px" : "",
                  }}
                  aria-hidden="true"
                ></i>
              </div> */}
              <div className="custom-btn" onClick={handleExport}>
                <i
                  class="fa fa-download"
                  style={{
                    fontSize: window.innerWidth >= 1800 ? "20px" : "",
                  }}
                  aria-hidden="true"
                ></i>
              </div>
              <div className="custom-btn" onClick={handleReset}>
                <i
                  class="fa fa-times"
                  style={{
                    fontSize: window.innerWidth >= 1800 ? "20px" : "",
                  }}
                  aria-hidden="true"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div style={{ marginTop: "20px" }}>
          <Loader />
        </div>
      ) : (
        <>
          <div style={{ margin: window.innerWidth > 1800 ? "50px" : "" }}>
            <div style={{ marginTop: customMargin }}>
              <StatsComponent Data={statsOption} />
            </div>

            <div className="row" style={{ marginTop: customMargin }}>
              <div className="col-sm-6 col-xs-12">
                <div>
                  <HorziBarChartsMain
                    heading={"Approved vs Disbursed Trend"}
                    xAxisDataKey={"date"}
                    barData={chartData}
                    dataKeyName1={"approvedCount"}
                    dataKeyName2={"disbursedCount"}
                    barcolor1={"#ebb569ff"}
                    barcolor2={"#0d6e63ff"}
                    LegendLeft={"Approved"}
                    LegendRight={"Disbursed"}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-xs-12">
                <div>
                  <AreaCharts
                    showFilters={false}
                    heading={"Approval → Disbursement Time Trend"}
                    AreaData={chartData}
                    DataKeyName={"averageDaysToDisbursement"}
                    colorType={"blue"}
                    xDataKeyName={"date"}
                  />
                </div>
              </div>
            </div>

            <div className="row" style={{ marginTop: customMargin }}>
              <div className="col-xs-12">
                <div className="customDash-table" style={{ marginTop: "20px" }}>
                  <div>
                    <h5>Approved Leads</h5>
                  </div>
                  <div className="main-customized-table">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Application Id</th>
                          <th>Lead Name</th>
                          <th>Approved Amount</th>
                          <th>Approval Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData?.length > 0
                          ? tableData?.map((val, id) => {
                              return (
                                <tr key={id}>
                                  <td>{val?.applicationId}</td>
                                  <td>{val?.userName}</td>
                                  <td>{val?.approveAmount}</td>
                                  <td>{val?.approveDate}</td>
                                </tr>
                              );
                            })
                          : ""}
                      </tbody>
                    </table>
                  </div>
                </div>
                {totalCount > 0 && (
                  <Stack
                    direction="row"
                    justifyContent="end"
                    alignItems="center"
                    sx={{ mt: 2 }}
                  >
                    <Pagination
                      count={Math.ceil(totalCount / noOfRows)}
                      page={pageNumber}
                      onChange={(e, value) => setPageNumber(value)}
                      // color="#43a4c7"
                      // shape="rounded"
                      sx={{
                        "& .MuiPaginationItem-root": {
                          color: "#006c67",
                          fontSize: window.innerWidth >= 1800 ? "20px" : "14px",
                          minWidth: window.innerWidth >= 1800 ? "40px" : "32px",
                          height: window.innerWidth >= 1800 ? "40px" : "32px",
                        },
                        "& .MuiPaginationItem-root.Mui-selected": {
                          backgroundColor: "#006c67",
                          color: "#fff",
                        },
                      }}
                    />
                  </Stack>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
